/* import __COLOCATED_TEMPLATE__ from './copilot.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
/* eslint-disable @intercom/intercom/no-bare-strings */

import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { next } from '@ember/runloop';
import type Nexus from 'embercom/services/nexus';
import { inject as service } from '@ember/service';

interface CopilotPreviewArgs {
  previewMode: 'agent' | 'copilot';
  onSelectPreviewMode: (mode: 'agent' | 'copilot') => void;
}

export default class CopilotPreview extends Component<CopilotPreviewArgs> {
  @tracked renderCopilotAdapter = true;
  @service declare nexus: Nexus;

  constructor(owner: unknown, args: CopilotPreviewArgs) {
    super(owner, args);
    if (!this.nexus.isConnected) {
      this.nexus.start();
    }
  }

  @action async resetPreview() {
    this.renderCopilotAdapter = false;
    next(() => {
      this.renderCopilotAdapter = true;
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinAiAgent::Knowledge::Previews::Copilot': typeof CopilotPreview;
    'fin-ai-agent/knowledge/previews/copilot': typeof CopilotPreview;
  }
}
